import {
  As,
  TextAlign,
  TextTransform,
  TextVariant,
  TextWeight,
} from "cms/theme/theme";
import React from "react";
import { TextContainer } from "./Text.styles";

export interface TextProps {
  variant: TextVariant;
  children: React.ReactNode;
  weight?: TextWeight;
  textAlign?: TextAlign;
  textTransform?: TextTransform;
  color?: string;
  ellipsis?: boolean;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  as?: As;
}

const Text: React.FC<TextProps> = ({
  variant,
  weight,
  textAlign,
  textTransform,
  color,
  ellipsis,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  as = "div",
  children,
}) => (
  <TextContainer
    $variant={variant}
    $weight={weight}
    $textAlign={textAlign}
    $textTransform={textTransform}
    $color={color}
    $ellipsis={ellipsis}
    $marginTop={marginTop}
    $marginBottom={marginBottom}
    $marginLeft={marginLeft}
    $marginRight={marginRight}
    as={as}
  >
    {children}
  </TextContainer>
);

export default Text;
